import React from "react";
import PropTypes from 'prop-types';
import CustomPropTypes from "../../utils/customPropTypes";
import ImageBlock from "../ImageBlock";
import SafeHTML from "../SafeHTML";
import scrollToElement from 'scroll-to-element';
import { Popup } from 'semantic-ui-react'
import 'semantic-ui-css/components/popup.min.css';
import ApplicationCategoryView from "./ApplicationCategoryView";
const style = {
    opacity: 0.8,
}

export default class ApplicationCategoryCard extends React.Component {
    static propTypes = {
        category: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            image: CustomPropTypes.Image
        }),
        parentCategory: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            image: CustomPropTypes.Image
        }),
        onViewDetail: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            active: false
        };
    }
    handleClick = () => {
        if (this.props.onViewDetail) {
            var currentCat = this.props.category;
            this.props.onViewDetail(currentCat);
        }
    };
    getCardHTML(currentCat) {
        return <div className="product-card-inner">
            <h4 className="product-card-title">{currentCat.name}</h4>
            <div className="product-card-object">
                <ImageBlock image={currentCat.image} addWrapper={false} />
            </div>
            <div className="product-card-action">
                {/* <span className="learn_more">Learn More</span> */}
                <span className="learn_more">Learn More</span>
                <i className="icon icon-direction-right new-design-arrow-icon"></i>
            </div>
        </div>
    }
    getCardWithTooltipIfRequired() {
        let currentCat = this.props.category;
        if ((currentCat.applications > 0)
            || (currentCat.subcategories && currentCat.subcategories.length > 0)) {
            return this.getCardHTML(currentCat);
        }
        else {
            return <Popup inverted style={style} trigger={this.getCardHTML(currentCat)} on="click">
                <Popup.Content>No application found for '{currentCat.name}'</Popup.Content>
            </Popup>
        }

    }
    render() {
        let objAppCategory = this.props.category;
        if (objAppCategory)
            return (
                <>
                    <a
                        className="product-card"
                        onClick={() => {
                            this.handleClick();
                        }}
                    >
                        {this.getCardWithTooltipIfRequired()}

                    </a>
                </>
            );
        else return null;
    }
}
